import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const AuthGuard = ({ children }) => {
  const { userInfo: user, loading: authLoading } = useAuth();
  const location = useLocation();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (!authLoading) {
      setIsInitialized(true);
    }
  }, [authLoading]);

  if (!isInitialized || authLoading) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '100vh',
          '@media (max-width: 767px)': {
            minHeight: '100dvh',
          },
          bgcolor: '#000'
        }}
      >
        <CircularProgress sx={{ color: '#21cbf3' }} />
      </Box>
    );
  }

  if (!user) {
    return (
      <Navigate 
        to="/login" 
        state={{ from: location.pathname }} 
        replace 
      />
    );
  }

  return children;
};

export default AuthGuard;